var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8563 3.77426H14.7134H12.4134L11.8349 1.45997C11.7563 1.13854 11.4706 0.917114 11.142 0.917114H6.85631C6.52773 0.917114 6.24202 1.13854 6.16345 1.45997L5.58488 3.77426H3.28488H1.14202C0.749163 3.77426 0.427734 4.09569 0.427734 4.48854C0.427734 4.8814 0.749163 5.20283 1.14202 5.20283H2.57059V20.2028C2.57059 20.5957 2.89202 20.9171 3.28488 20.9171H14.7134C15.1063 20.9171 15.4277 20.5957 15.4277 20.2028V5.20283H16.8563C17.2492 5.20283 17.5706 4.8814 17.5706 4.48854C17.5706 4.09569 17.2492 3.77426 16.8563 3.77426ZM11.8563 8.05997V16.6314C11.8563 17.0243 11.5349 17.3457 11.142 17.3457C10.7492 17.3457 10.4277 17.0243 10.4277 16.6314V8.05997C10.4277 7.66711 10.7492 7.34569 11.142 7.34569C11.5349 7.34569 11.8563 7.66711 11.8563 8.05997ZM6.14202 8.05997C6.14202 7.66711 6.46345 7.34569 6.85631 7.34569C7.24916 7.34569 7.57059 7.66711 7.57059 8.05997V16.6314C7.57059 17.0243 7.24916 17.3457 6.85631 17.3457C6.46345 17.3457 6.14202 17.0243 6.14202 16.6314V8.05997ZM7.41345 2.34569H10.5849L10.942 3.77426H7.05631L7.41345 2.34569Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.9e6057d8210ca70b8755fe08db2679bd.svg";
export { ForwardRef as ReactComponent };